import React from 'react'
import { Grid, Skeleton } from "@mui/material"
import { isAnalyzerLoading, responseData } from "Pages/AnalyzersV2/@signals"
import { AnalyzerEvolutionModal, AnalyzerPricesChart, AnalyzersTable } from "Pages/AnalyzersV2/@components"
import useAnalyzerData from "Pages/AnalyzersV2/@hooks/useData"
import { NoDataFound } from "@components"


export default function RatingContent() {
	const {
		tableData,
		tableColumns,
		dataEmpty,
		evolutionData,
		chartContent,
		noResults
	} = useAnalyzerData(responseData.value)

	if (noResults) {
		return <NoDataFound/>
	}

	if (dataEmpty && !isAnalyzerLoading.value) return <></>

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			{isAnalyzerLoading.value && <Skeleton variant="rectangular" height={300}/>}
			{!isAnalyzerLoading.value &&
				<AnalyzersTable
					tableData={tableData}
					columns={tableColumns}
					evolutionData={evolutionData}
					isRating={true}
					hideIcon
				/>}
		</Grid>
		<Grid item xs={12}>
			<AnalyzerPricesChart {...chartContent} isRating={true}/>
		</Grid>
		<Grid item xs={12}>
			<AnalyzerEvolutionModal isRating={true} l/>
		</Grid>
	</Grid>

}